// eslint-disable-next-line
import { BasicLayout, RouteView } from '@/layouts'

export default [
  {
    path: '/',
    name: 'index',
    component: BasicLayout,
    meta: { title: '系统' },
    redirect: '/operating/dashboard',
    children: [
      {
        path: '/operating',
        name: 'operating',
        component: RouteView,
        meta: { title: '运营中心', icon: 'sketch' },
        redirect: '/operating/dashboard',
        children: [
          {
            name: 'operatingDashboard',
            path: '/operating/dashboard',
            component: () => import('@/views/operating/dashboard/index'),
            meta: {
              title: '工作台首页',
              show: true,
              permission: ['operatingDashboard']
            }
          },
          {
            name: 'composite',
            path: '/operating/composite',
            component: () => import('@/views/operating/composite/index'),
            meta: {
              title: '内容创作',
              show: true,
              permission: ['operatingComposite']
            }
          },
          {
            name: 'freeCreation',
            path: '/operating/free-creation',
            component: () => import('@/views/operating/freeCreation/index'),
            meta: {
              title: '自由创作(beta)',
              show: true,
              permission: ['operatingComposite']
            }
          },
          {
            name: 'topicGeneration',
            path: '/operating/topic-generation',
            component: () => import('@/views/operating/topicGeneration/index.vue'),
            meta: {
              title: '选题生成(beta)',
              show: true,
              permission: ['operatingTopicGeneration']
            }
          },
          {
            name: 'composition',
            path: '/operating/composition',
            component: () => import('@/views/operating/composition/index'),
            meta: {
              title: '作品管理',
              show: true,
              permission: ['operatingcomposition']
            }
          },
          {
            name: 'plan',
            path: '/operating/plan',
            component: () => import('@/views/operating/plan/index'),
            meta: {
              title: '投放计划',
              show: true,
              permission: ['operatingDashboard']
            }
          },
          {
            name: 'launchData',
            path: '/operating/launch-data',
            component: () => import('@/views/operating/launchData/index'),
            meta: {
              title: '投放数据',
              show: true,
              permission: ['operatingDashboard']
            }
          },
          {
            name: 'clueManage',
            path: '/operating/clueManage',
            component: () => import('@/views/operating/clueManage/index'),
            meta: {
              title: '线索管理',
              show: true,
              permission: ['operatingDashboard']
            }
          },
          {
            name: 'clueManageEdit',
            path: '/operating/clueManageEdit',
            component: () => import('@/views/operating/clueManage/edit.vue'),
            hidden: true,
            meta: {
              title: '线索管理',
              show: true,
              permission: ['operatingDashboard']
            }
          },
          {
            name: 'launchLeads',
            path: '/operating/launch-leads',
            component: () => import('@/views/operating/launchLeads/index'),
            meta: {
              title: '投放线索',
              show: true,
              permission: ['operatingDashboard']
            }
          }
          // {
          //   name: 'contentReview',
          //   path: '/operating/content-review',
          //   component: () => import('@/views/operating/contentReview/index.vue'),
          //   meta: {
          //     title: '内容审查',
          //     show: true,
          //     permission: ['operatingContentReview']
          //   }
          // }
          // {
          //   name: 'textReview',
          //   path: '/operating/content-review/text',
          //   component: () => import('@/views/operating/contentReview/TextReview.vue'),
          //   meta: {
          //     title: '文本审查',
          //     show: true,
          //     permission: ['operatingContentReview']
          //   }
          // }
        ]
      },
      {
        path: '/geo',
        name: 'geo',
        component: RouteView,
        meta: { title: 'GEO看板', icon: 'global' },
        redirect: '/geo/overview',
        children: [
          {
            name: 'keywordManagement',
            path: '/geo/keyword-management',
            component: () => import('@/views/dataAnalysis/keyword/index.vue'),
            meta: {
              title: '关键词管理',
              show: true,
              permission: ['operatingDashboard']
            }
          },
          {
            name: 'geoSeo',
            path: '/geo/seo',
            component: () => import('@/views/dataAnalysis/seo/index.vue'),
            meta: {
              title: '内容分析看板',
              show: true,
              permission: ['operatingDashboard']
            }
          },
          {
            name: 'productManagement',
            path: '/geo/product',
            component: () => import('@/views/dataAnalysis/product/index.vue'),
            meta: {
              title: '关键词频率监控',
              show: true,
              permission: ['operatingDashboard']
            }
          },
          {
            name: 'brandVisibility',
            path: '/geo/brand-visibility',
            component: () => import('@/views/dataAnalysis/brand/index.vue'),
            meta: {
              title: '品牌可见性',
              show: true,
              permission: ['operatingDashboard']
            }
          },
          {
            name: 'geoOverview',
            path: '/geo/overview',
            component: () => import('@/views/dataAnalysis/overview/index.vue'),
            meta: {
              title: '投放概览',
              show: true,
              permission: ['operatingDashboard']
            }
          }
        ]
      },
      {
        path: '/setting',
        name: 'setting',
        component: RouteView,
        meta: { title: '系统设置', icon: 'slack', permission: ['dashboard'] },
        redirect: '/setting/baseInfo',
        children: [
          {
            path: '/setting/baseInfo',
            name: 'baseInfo',
            component: () => import('@/views/setting/baseInfo/index.vue'),
            meta: { title: '基本信息', keepAlive: true, permission: ['dashboard'] }
          },
          {
            path: '/setting/baseInfo/details',
            name: 'baseInfoDetails',
            hidden: true,
            component: () => import('@/views/setting/baseInfo/details.vue'),
            meta: { title: '基本信息详情', keepAlive: false, permission: ['dashboard'] }
          },
          {
            path: '/setting/pelrson',
            name: 'person',
            component: () => import('@/views/setting/person/index.vue'),
            meta: { title: '人员', permission: ['dashboard'] }
          },
          {
            path: '/setting/person/edit',
            name: 'personEdit',
            hidden: true,
            component: () => import('@/views/setting/person/edit.vue'),
            meta: { title: '人员编辑', keepAlive: false, permission: ['dashboard'] }
          },
          {
            path: '/setting/mediaAccount',
            name: 'mediaAccount',
            component: () => import('@/views/setting/mediaAccount/index.vue'),
            meta: { title: '新媒体账号管理', keepAlive: true, permission: ['dashboard'] }
          },
          {
            path: '/setting/knowledgeBase',
            name: 'knowledgeBase',
            component: () => import('@/views/setting/knowledgeBase/index.vue'),
            meta: { title: '知识库', keepAlive: false, permission: ['dashboard'] }
          },
          {
            name: 'knowledgeBaseEdit',
            path: '/setting/knowledgeBase/edit',
            component: () => import('@/views/setting/knowledgeBase/edit.vue'),
            hidden: true,
            meta: { title: '知识库编辑', keepAlive: false, permission: ['dashboard'] }
          }
          /* {
            path: '/setting/webContainer',
            name: 'webContainer',
            component: () => import('@/views/webcontainer/WebContainerReal.vue'),
            meta: { title: 'WBDEMO', keepAlive: true, permission: ['dashboard'] }
          },
          {
            path: '/setting/webContainerDemo',
            name: 'webContainerDemo',
            component: () => import('@/views/webcontainer/WebContainerDemo.vue'),
            meta: { title: 'WBCONTAINER', keepAlive: true, permission: ['dashboard'] }
          }, */
          // {
          //   name: 'externalAddress',
          //   path: 'https://zhiweihub-6-1751871868897.netlify.app/',
          //   meta: { title: '智能BI', target: '_blank', show: false }
          // }
        ]
      }
    ]
  },
  {
    path: '*',
    redirect: '/404',
    hidden: true
  }
]
